<div class="acount-nav"  >
  <div class="w-full flex flex-col lg:flex-row">
    <div class="w-full lg:w-1/2 account">
      <div>
        <p class="strong pt-3 pl-3">Account</p>
        <div class="mb-4">
          <div *ngFor="let org of coopListSignal()" class="my-2">
            <a
              class="flex items-center h-12 cursor-pointer"
              [ngClass]="org?.setActive ? 'active' : ''"
              (click)="switchEntityPro(org)"
              tabindex="0"
              role="navigation"
            >
              <div class="profile-img ml-2">
                <div *ngIf="org.logoImageUrl as url; else placeholder">
                  <img [src]="url" alt="Profile Picture" />
                </div>
                <ng-template #placeholder>
                  <div class="h-10 w-10">
                    <img
                      *ngIf="org.entityType == 'Individual'"
                      src="assets/images/profile/individual-icon.svg"
                      alt="Default profile picture for individual"
                    />
                    <img
                      *ngIf="org.entityType == 'Organization'"
                      src="assets/images/profile/organization-icon.svg"
                      alt="Default profile picture for organization"
                    />
                    <img
                      *ngIf="org.entityType == 'Coop'"
                      src="assets/images/profile/organization-icon.svg"
                      alt="Default profile picture for cooperative"
                    />
                  </div>
                </ng-template>
              </div>
              <div class="ml-2">
                <p>{{ org?.entityName  | truncateText: 25}}</p>
              </div>
             
            </a>
          </div>
        </div>
      </div>
      <div class="button-wrapper">
        <button class="items-center darkGrey-link" (click)="logout()">
          <mat-icon>arrow_forward</mat-icon>
          Log Out
        </button>
      </div>
    </div>
    <div class="w-full lg:w-1/2 current-account">
      <div class="text-center mt-4">
        <div *ngFor="let org of coopListSignal()"   [ngClass]="org?.setActive ? 'active' : 'hidden'">
          <div class="profile-img flex justify-center">
            <div class="flex justify-center" *ngIf="org.logoImageUrl as url; else placeholder">
              <img [src]="url" alt="Profile Picture" />
            </div>
            <ng-template #placeholder>
              <div>
                <img
                  *ngIf="org.entityType == 'Individual'"
                  src="assets/images/profile/individual-icon.svg"
                  alt="Default profile picture for individual"
                />
                <img
                  *ngIf="org.entityType == 'Organization'"
                  src="assets/images/profile/organization-icon.svg"
                  alt="Default profile picture for organization"
                />
                <img
                  *ngIf="org.entityType == 'Coop'"
                  src="assets/images/profile/organization-icon.svg"
                  alt="Default profile picture for cooperative"
                />
              </div>
            </ng-template>
          </div>
          <div class="mt-1 text-center">
            <p class="org-name bold">{{ org?.entityName  | truncateText: 25}}</p>
            <p class="role-tag mx-auto"> {{ this.organizationService.getOrgChipLabel(org) }} </p>
          </div>

          <ng-container *ngIf="organizationService.getOrgChipLabel(org) == 'Org Admin'; else personal">
            <div class="mt-3 px-3">
              <!-- <a routerLink="" (click)="closeHeader()">
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 80l91.4 0c80 0 145 64.3 146.3 144L32 480c1.2-79.7 66.2-144 146.3-144zm0-32C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0zM512 304c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 80z"/></svg>
                  </span>
                  <span class="ml-2">
                    Invite Org Admin
                  </span>
               </a> -->
              <a routerLink="/organization/profile" (click)="closeHeader()">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M223.3 37.8c.4-1.5 1.3-2.8 2.4-3.8c9.9-1.3 20-2 30.3-2s20.4 .7 30.3 2c1.1 1 1.9 2.3 2.4 3.8l13.7 47.7c3.5 12.1 12.2 21.1 22.5 26.1c7.6 3.6 14.8 7.8 21.7 12.5c9.4 6.5 21.7 9.5 33.9 6.5l48.2-12c1.5-.4 3-.3 4.4 .2c5.4 6.9 10.4 14.2 14.9 21.8l4.3 7.4c4.2 7.5 7.9 15.3 11.2 23.3c-.3 1.5-1 2.9-2.1 4L426.8 211c-8.7 9-12.2 21.1-11.3 32.5c.3 4.1 .5 8.3 .5 12.5s-.2 8.4-.5 12.5c-.9 11.4 2.6 23.5 11.3 32.5l34.5 35.7c1.1 1.1 1.8 2.5 2.1 4c-3.3 8-7 15.8-11.2 23.4l-4.2 7.3c-4.6 7.6-9.6 14.8-14.9 21.8c-1.4 .5-2.9 .5-4.4 .2l-48.2-12c-12.2-3-24.4 0-33.9 6.5c-6.9 4.7-14.1 8.9-21.7 12.5c-10.3 4.9-19.1 14-22.5 26.1l-13.7 47.7c-.4 1.5-1.3 2.8-2.4 3.8c-9.9 1.3-20 2-30.3 2s-20.4-.7-30.3-2c-1.1-1-1.9-2.3-2.4-3.8l-13.7-47.7c-3.5-12.1-12.2-21.1-22.5-26.1c-7.6-3.6-14.8-7.8-21.7-12.5c-9.4-6.5-21.7-9.5-33.9-6.5l-48.2 12c-1.5 .4-3 .3-4.4-.2c-5.4-7-10.4-14.2-15-21.8l-4.2-7.3c-4.2-7.5-7.9-15.3-11.2-23.4c.3-1.5 1-2.9 2.1-4L85.2 301c8.7-9 12.2-21.1 11.3-32.5c-.3-4.1-.5-8.3-.5-12.5s.2-8.4 .5-12.5c.9-11.4-2.6-23.5-11.3-32.5L50.7 175.2c-1.1-1.1-1.8-2.5-2.1-4c3.3-8 7-15.8 11.2-23.4l4.2-7.3c4.6-7.6 9.6-14.8 15-21.8c1.4-.5 2.9-.5 4.4-.2l48.2 12c12.2 3 24.4 0 33.9-6.5c6.9-4.7 14.1-8.9 21.7-12.5c10.3-4.9 19.1-14 22.5-26.1l13.7-47.7zM256 0c-13 0-25.9 1-38.4 2.9c-1.7 .3-3.4 .8-5 1.6c-9.5 4.9-16.9 13.6-20 24.5L178.9 76.7c-.6 2.2-2.5 4.5-5.6 6c-9.1 4.3-17.8 9.4-26 15c-2.8 1.9-5.8 2.4-8 1.8l-48.2-12C80.2 84.8 69 86.9 60 92.6c-1.5 .9-2.8 2.1-3.9 3.5C49 105 42.4 114.3 36.5 124.1l-.1 .3L32 132l-.1 .3c-5.4 9.8-10.2 19.9-14.3 30.4c-.6 1.6-1 3.3-1.1 5c-.5 10.8 3.3 21.6 11.2 29.8l34.5 35.7c1.6 1.7 2.7 4.4 2.4 7.8c-.4 5-.6 10-.6 15s.2 10.1 .6 15c.3 3.4-.8 6.2-2.4 7.8L27.7 314.6c-7.9 8.2-11.7 19-11.2 29.8c.1 1.7 .5 3.4 1.1 5c4.1 10.5 8.9 20.6 14.3 30.4l.1 .3 4.4 7.6 .1 .3c5.9 9.8 12.4 19.2 19.6 28.1c1.1 1.4 2.4 2.6 3.9 3.5c9 5.7 20.2 7.8 31.1 5.1l48.2-12c2.2-.6 5.2-.1 8 1.8c8.2 5.7 16.9 10.7 26 15c3.1 1.5 4.9 3.8 5.6 6L192.6 483c3.1 10.8 10.5 19.5 20 24.5c1.6 .8 3.2 1.4 5 1.6C230.1 511 243 512 256 512s25.9-1 38.4-2.9c1.7-.3 3.4-.8 5-1.6c9.5-4.9 16.9-13.6 20-24.5l13.7-47.7c.6-2.2 2.5-4.5 5.6-6c9.1-4.3 17.8-9.4 26-15c2.8-1.9 5.8-2.4 8-1.8l48.2 12c10.9 2.7 22.1 .7 31.1-5.1c1.5-.9 2.8-2.1 3.9-3.5c7.1-8.9 13.6-18.2 19.5-28l.2-.3L480 380l.1-.3c5.4-9.7 10.2-19.9 14.3-30.4c.6-1.6 1-3.3 1.1-5c.5-10.8-3.3-21.6-11.2-29.8l-34.5-35.7c-1.6-1.7-2.7-4.4-2.4-7.8c.4-5 .6-10 .6-15s-.2-10.1-.6-15c-.3-3.4 .8-6.2 2.4-7.8l34.5-35.7c7.9-8.2 11.7-19 11.2-29.8c-.1-1.7-.5-3.4-1.1-5c-4.1-10.5-8.9-20.6-14.3-30.4l-.1-.3-4.4-7.6-.2-.3c-5.9-9.8-12.4-19.2-19.5-28c-1.1-1.4-2.4-2.6-3.9-3.5c-9-5.7-20.2-7.8-31.1-5.1l-48.2 12c-2.2 .6-5.2 .1-8-1.8c-8.2-5.7-16.9-10.7-26-15c-3.1-1.5-4.9-3.8-5.6-6L319.4 29c-3.1-10.8-10.5-19.5-20-24.5c-1.6-.8-3.2-1.4-5-1.6C281.9 1 269 0 256 0zM200 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0z"/></svg>
                </span>
                <span class="ml-2">
                  Settings
                </span>
                </a>
            </div>
          </ng-container>
          <ng-template  #personal>
            <div class="mt-3 px-3">
              <a routerLink="/profile"  [queryParams]="{ createOrg: true }" (click)="closeHeader()">
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M448 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-384c0-17.7 14.3-32 32-32l160 0zM288 0c-35.3 0-64 28.7-64 64l0 384c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L288 0zM192 128L64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l152.4 0c-8.3-9.2-14.8-20.1-19-32L64 480c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l128 0 0-32zM88 320c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 64l0-32 32 0 0 32-32 0zm224 8c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 48zm32-8l0-32 32 0 0 32-32 0zM88 192c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 64l0-32 32 0 0 32-32 0zM320 88l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm32 8l32 0 0 32-32 0 0-32zm-8 192l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24zm8-64l32 0 0 32-32 0 0-32z"/></svg>
                  </span>
                  <span class="ml-2">
                    Create Org
                  </span>
               </a>
              <a routerLink="/profile" (click)="closeHeader()">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M412.1 416.6C398.1 361.1 347.9 320 288 320l-64 0c-59.9 0-110.1 41.1-124.1 96.6C58 375.9 32 319 32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 63-26 119.9-67.9 160.6zm-28.5 23.4C347.5 465.2 303.5 480 256 480s-91.5-14.8-127.7-39.9c4-49.3 45.3-88.1 95.7-88.1l64 0c50.4 0 91.6 38.8 95.7 88.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-256a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z"/></svg>
                </span>
                <span class="ml-2">
                  Profile
                </span>
                </a>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>